module.exports = __webpack_public_path__ + "static/pd3-472c5eded185f4605956a8c6863f3bcc.png";